export default __webpack_public_path__ + "static/media/Jim.f8aa1fe5.png";